<template>
  <div>
    <el-button size="small" type="primary" @click="addBtn">新增</el-button>
    <div class="content">
      <el-table
      :data="tableData"
      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
      style="width: 100%">
        <el-table-column prop="name" label="供应商公司名称" width="130px"></el-table-column>
        <el-table-column prop="type" label="供应商类型" width="130px"></el-table-column>
        <el-table-column prop="address" label="公司地址" width="130px"></el-table-column>
        <el-table-column prop="contact" label="联系人" width="130px"></el-table-column>
        <el-table-column prop="contactTel" label="联系电话" width="130px"></el-table-column>
        <el-table-column prop="riskLevel" label="供应商风险评级" width="130px"></el-table-column>
        <el-table-column prop="classify" label="供应商类别" width="130px"></el-table-column>
        <el-table-column prop="postcode" label="邮政编码" width="130px"></el-table-column>
        <el-table-column prop="businessScope" label="经营范围" width="130px"></el-table-column>
        <el-table-column prop="intro" label="公司描述" width="130px"></el-table-column>
        <el-table-column prop="assessTime" label="考核日期" width="130px">
          <template slot-scope="{ row }">
            {{ row.assessTime | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="score" label="总分" width="130px"></el-table-column>
        <el-table-column prop="result" label="考核结果" width="130px"></el-table-column>
        <el-table-column prop="cerName" label="证书名称" width="130px"></el-table-column>
        <el-table-column prop="cerNum" label="证书编号" width="130px"></el-table-column>
        <el-table-column prop="indate" label="是否有有效期" width="130px">
          <template slot-scope="{ row }">
            {{ row.indate === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="licenceIssued" label="取证日期" width="130px">
          <template slot-scope="{ row }">
            {{ row.licenceIssued | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="expiringDate" label="到期日期" width="130px">
          <template slot-scope="{ row }">
            {{ row.expiringDate | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="assessTitle" label="考核标题" width="130px"></el-table-column>
        <el-table-column prop="assessDep" label="考核部门" width="130px"></el-table-column>
        <el-table-column label="操作" width="120px" fixed="right">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" @click="editBtn(row)">编辑</el-link>
            <span style="padding: 0 8px; color: #e8e8e8">|</span>
            <el-link :underline="false" type="danger" @click="deleteBtn(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>
  </div>
</template>

<script>
import { supplierManagerList, supplierManagerDelete } from "@/api/processManager"
export default {
  name: 'supplierManager',
  data() {
    return {
      tableData: [],
      limit: 10,
      curPage: 1,
      total: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      supplierManagerList({ limit: this.limit, curPage: this.curPage, isPage: 1 }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    curPageChange(val) {
      this.curPage = val
      this.getData()
    },
    addBtn() {
      this.$router.push('AddSupplierManager')
    },
    editBtn(row) {
      this.$router.push({
        name: 'AddSupplierManager',
        params: { key: row }
      })
    },
    deleteBtn(row) {
      supplierManagerDelete(row.id).then(res => {
        this.$message.success('删除成功')
        this.getData()
      })
    }
  }
}
</script>

<style scoped>

</style>
